import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import { getApi } from 'views/services/api';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import Iconify from 'ui-component/iconify';
import ShowAllFoodItem from './showAllFoodItem';
import CheckInReservation from '../CheckInReservation';
import EditReservation from '../EditReservation';
import AddReservation from '../AddReservations';
import RoomInvoiceDialog from './RoomInvoiceDialog';
import CheckOut from '../CheckOutReservation';
import ShowBill from './ShowBills';
import FoodInvoiceDialog from './FoodInvoiceDialog';
import SingleInvoiceDialog from './SingleInvoiceDialog';
import Visitor from 'views/VisitorInformation';
import { constant } from 'views/constant';
import { patchApi } from 'views/services/api';
import axios from 'axios';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

export default function ReservationDashboard() {
  const navigate = useNavigate();

  const [openEdit, setOpenEdit] = useState(false);
  const [tabOption, setTabOption] = React.useState('1');
  const [firstTabOption, setFirstTabOption] = React.useState('1');
  const [openAdd, setOpenAdd] = useState(false);
  const [openGenerateInv, setOpenGenerateInv] = useState(false);
  const [openFoodInv, setOpenFoodInv] = useState(false);
  const [openSingleInv, setOpenSingleInv] = useState(false);
  const [totalFoodAmount, setTotalFoodAmount] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [openCheckIn, setOpenCheckIn] = useState(false);
  const [reservationData, setReservationData] = useState([]);
  const params = useParams();
  console.log("in reservation dashboard ==>",params);
  
  
  // eslint-disable-next-line
  const [isRoomStatusPending, setisRoomStatusPending] = useState(false);

  const [isRoomCheckedIn, setIsRoomCheckedIn] = useState(false);
  const [billData, setbillData] = useState([]);
  const [singleBillData, setSingleBillData] = useState([]);
  const [isRoomCheckedOut, setIsRoomCheckedOut] = useState(false);
  const reservationId = params.id;
  console.log("ye reservation ki _id hai ==>",reservationId);
  

  const FinalCheckInTime = moment().format('hh:mm A');
  const hotelData = JSON.parse(localStorage.getItem('hotelData'));

  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenEditlead = () => setOpenEdit(true);
  const handleCloseEditReservation = () => setOpenEdit(false);

  const handleOpenGenerateRoomDialog = () => {
    setOpenGenerateInv(true);
  };

  const handleCloseGenerateRoomInvoiceDialog = () => {
    setOpenGenerateInv(false);
  };

  const handleOpenFoodInvoice = () => {
    setOpenFoodInv(true);
  };

  const handleCloseFoodInvoice = () => {
    setOpenFoodInv(false);
  };
  const handleOpenSingleInvoice = () => {
    setOpenSingleInv(true);
  };

  const handleCloseSingleInvoice = () => {
    setOpenSingleInv(false);
  };

  const handleOpenCheckOut = () => {
    const checkOutDate = new Date(reservationData?.checkOutDate).getDate();
    const currentDate = new Date().getDate();
    if (currentDate !== checkOutDate) {
      toast.error('Cannot Check-Out Today. Please check Check-Out Date.');
    } else {
      setOpenDelete(true);
    }
  };
  const handleCloseCheckout = () => {
    setOpenDelete(false);
  };

  const handleOpenCheckIn = () => {
    setOpenCheckIn(true);
  };
  const handleCloseCheckIn = () => setOpenCheckIn(false);

  // ----------------------------------------------------------------------

  const fetchbillData = async () => {
    try {
      const response = await getApi(`api/invoice/view/${reservationId}`);
      setbillData(response?.data?.InvoiceData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSingleBillData = async () => {
    try {
      const response = await getApi(`api/singleinvoice/view/${reservationId}`);
      setSingleBillData(response?.data?.InvoiceData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetechReservationData = async () => {
    try {
      console.log('---->',reservationId);
      
      const response = await getApi(`api/reservation/view/${reservationId}`);
      setReservationData(response.data.reservationData[0]);
      console.log("herehere gere =>",response.data);
      //conditionaly showing buttons
      if (response.data.reservationData[0].status === 'pending') {
        setisRoomStatusPending(true);
      } else if (response.data.reservationData[0].status === 'active') {
        setIsRoomCheckedIn(true);
      } else {
        setIsRoomCheckedOut(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchbillData();
    fetchSingleBillData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openGenerateInv, openFoodInv, openSingleInv]);

  useEffect(() => {
    fetechReservationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, openEdit, openDelete, openCheckIn, openGenerateInv, openFoodInv, openSingleInv]);

  const calculateTotalFoodAmount = () => {
    if (!reservationData || !reservationData.foodItems) {
      return 0;
    }

    const totalFoodAmount = reservationData.foodItems.reduce((total, foodData) => {
      return total + foodData.quantity * foodData.price;
    }, 0);

    return totalFoodAmount;
  };

  useEffect(() => {
    setTotalFoodAmount(calculateTotalFoodAmount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationData]);

  //handle add food
  const handleAddFoodClick = () => {
    navigate(`/dashboard/reservation/addfood/${reservationId}`);
  };

  const handleTabChange = (event, newValue) => {
    setTabOption(newValue);
  };

  const handleFirstTabChange = (event, newValue) => {
    setFirstTabOption(newValue);
  };
  useEffect(() => {
    if (tabOption === '1') {
      setTabOption('2');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SingleInvoiceDialog, FoodInvoiceDialog, RoomInvoiceDialog]);

  console.log(singleBillData);

  const handleCheckIn = async () => {
    try {
      if (!isCheckInDateValid()) {
        toast.error('Cannot Check-In Today. Please Do another reservation or Edit Check-In Date.');
        return;
      } else {
        reservationData.FinalCheckInTime = FinalCheckInTime;
        sendWelcomeWhatsAppMessage();
        // let result = await patchApi(`api/reservation/checkin/${reservationId || reservationData._id}`, reservationData);
        // if (result.status === 200) {
        //   toast.success('Successfully Checked In');
        //   sendWelcomeWhatsAppMessage();
        //   handleClose();
        // } 
        // else {
        //   toast.error(result?.response?.data?.error);
        // }
      }
    } catch (error) {
      console.log(error);
      toast.error('Cannot Check-In');
    }
  };

  const isCheckInDateValid = () => {
    const checkInDate = moment(reservationData?.checkInDate).format('YYYY-MM-DD');
    const today = moment().format('YYYY-MM-DD');

    const isSameAsToday = checkInDate === today;

    return isSameAsToday;
  };

  const sendWelcomeWhatsAppMessage = async () => {
    console.log("in sendWelcomeWhatsAppMessage");
    const url = constant.WHATSAPP_MESSAGE_URL;
    const accessToken = constant.WHATSAPP_TOKEN;

    console.log(url, 'url');
    console.log(accessToken, 'accessToken');
    const payload = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: `+91${reservationData?.customerDetails?.phoneNumber}`,
      type: 'template',
      template: {
        name: 'welcome_msg_hotel_crm',
        language: {
          code: 'en_US'
        },
        components: [
          {
            type: 'header',
            parameters: [
              {
                type: 'text',
                text: hotelData?.name
              }
            ]
          },
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: hotelData?.contact
              },
              {
                type: 'text',
                text: hotelData?.mapurl
              },
              {
                type: 'text',
                text: hotelData?.name
              }
            ]
          }
        ]
      }
    };

    try {
      console.log("in try =>",);
      const response = await axios.post(url, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        }
      });
      console.log('response===>',response);
      console.log('Success:', response.reservationData);

    } catch (error) {
      console.error('Error:', error);
    }
  };


  return (
    <>
      <CheckOut open={openDelete} handleClose={handleCloseCheckout} data={reservationData} />
      <CheckInReservation open={openCheckIn} handleClose={handleCloseCheckIn} data={reservationData} />
      <AddReservation open={openAdd} handleClose={handleCloseAdd} />
      <EditReservation open={openEdit} handleClose={handleCloseEditReservation} data={reservationData} />
      <RoomInvoiceDialog open={openGenerateInv} handleClose={handleCloseGenerateRoomInvoiceDialog} data={reservationData} />
      <FoodInvoiceDialog open={openFoodInv} handleClose={handleCloseFoodInvoice} data={reservationData} />
      <SingleInvoiceDialog open={openSingleInv} handleClose={handleCloseSingleInvoice} data={reservationData} />
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={firstTabOption}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
            <TabList onChange={handleFirstTabChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
              <Tab label="Information" value="1" />
              <Tab label="Visitors" value="2" />
            </TabList>

            {/* //-----------buttons-------------------- */}
            <div>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Box>
          {/* //INFORMATION SECTION ------------------------------------------------------------------ */}
          <TabPanel value="1">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  {/* //-------------------- */}
                  <Item>
                    <Typography variant="h4" fontWeight="bold">
                      Room Information
                    </Typography>
                    <hr />

                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Room Number :</Typography>
                        <Typography style={{ color: 'black' }}>{reservationData?.roomNo ? reservationData?.roomNo : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Room Rent :</Typography>
                        <Typography style={{ color: 'black' }}>
                          Rs {reservationData?.totalPayment ? reservationData?.totalPayment : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Advance Amount :</Typography>
                        <Typography style={{ color: 'black' }}>
                          Rs {reservationData?.advanceAmount ? reservationData?.advanceAmount : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Remaining Amount:</Typography>
                        <Typography style={{ color: 'black' }}>
                          Rs {reservationData?.totalAmount ? reservationData?.totalAmount : 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Check-In :</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.checkInDate ? moment(reservationData?.checkInDate).format('YYYY-MM-DD') : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Check-Out:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.checkOutDate ? moment(reservationData?.checkOutDate).format('YYYY-MM-DD') : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Total Days :</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.totalDays ? reservationData?.totalDays : 'N/A'} days
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Total Restaurant Expense :</Typography>
                        <Typography style={{ color: 'black' }}>Rs {totalFoodAmount ? totalFoodAmount : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Total Amount ( Room + Restaurant ) :</Typography>
                        <Typography style={{ color: 'black' }}>
                          Rs{' '}
                          {reservationData?.totalPayment && totalFoodAmount
                            ? reservationData?.totalPayment + totalFoodAmount
                            : reservationData?.totalPayment}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Item>
                </Grid>

                {/* //customer Information______________________________________ */}
                <Grid item xs={12} md={6}>
                  <Item sx={{ height: '100%' }}>
                    <Typography variant="h4" fontWeight="bold">
                      Customer Information
                    </Typography>
                    <hr />
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={5}>
                        <Typography variant="h5">Name :</Typography>
                        <Typography style={{ color: 'black' }}>{reservationData?.fullName ? reservationData?.fullName : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={5}>
                        <Typography variant="h5"> Email:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.customerDetails?.email ? reservationData?.customerDetails?.email : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={5}>
                        <Typography variant="h5"> Phone Number:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.customerDetails?.phoneNumber ? reservationData?.customerDetails?.phoneNumber : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={5}>
                        <Typography variant="h5">Addresss:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.customerDetails?.address ? reservationData?.customerDetails?.address : 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={5}>
                        <Typography variant="h5">{reservationData?.customerDetails?.idCardType} Number:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {reservationData?.customerDetails?.idcardNumber ? reservationData?.customerDetails?.idcardNumber : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">ID Proof:</Typography>
                        <Typography style={{ color: 'black', marginTop: '7px' }}>
                          <a href={reservationData?.idFile} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                            <Button startIcon={<VisibilityIcon />} variant="contained" color="primary">
                              View ID Proof
                            </Button>
                          </a>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value="2">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Visitor isRoomCheckedOut={isRoomCheckedOut} />
            </Box>
          </TabPanel>
        </TabContext>
        <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'space-between', gap: 3 }}>
          {setisRoomStatusPending === true ? (
            <Box>
              <Button
                variant="outlined"
                sx={{ marginLeft: 4, color: '#673ab7', borderColor: '#673ab7' }}
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => handleAddFoodClick()}
              >
                Add Food
              </Button>
            </Box>
          ) : isRoomCheckedIn && !isRoomCheckedOut ? (
            <Box>
              <Button
                variant="outlined"
                sx={{ marginLeft: 4, color: '#673ab7', borderColor: '#673ab7' }}
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => handleAddFoodClick()}
              >
                Add Food
              </Button>
            </Box>
          ) : (
            <Box></Box>
          )}

          <Box>
            {isRoomCheckedOut && reservationData?.foodItems?.length > 0 && !singleBillData && (
              <Button
                variant="outlined"
                sx={{ marginRight: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => handleOpenSingleInvoice()}
              >
                Generate Single Invoice
              </Button>
            )}

            {!billData?.some((item) => item.type === 'room') && isRoomCheckedOut && (
              <Button
                variant="outlined"
                sx={{ marginRight: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => handleOpenGenerateRoomDialog()}
              >
                Generate Room Invoice
              </Button>
            )}

            {!billData?.some((item) => item.type === 'food') && isRoomCheckedOut && reservationData?.foodItems?.length > 0 && (
              <Button
                variant="outlined"
                sx={{ marginRight: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => handleOpenFoodInvoice()}
              >
                Generate Food Invoice
              </Button>
            )}

            {!isRoomCheckedIn && !isRoomCheckedOut ? (
              <Button
                variant="outlined"
                sx={{ marginRight: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => handleOpenCheckIn()}
              >
                Final Check-In
              </Button>
            ) : (
              ''
            )}

            {setisRoomStatusPending === true ? (
              <Button variant="outlined" sx={{ marginRight: 2 }} color="error" onClick={() => handleOpenCheckOut()}>
                Final Check-Out
              </Button>
            ) : isRoomCheckedIn && !isRoomCheckedOut ? (
              <Button variant="outlined" sx={{ marginRight: 2 }} color="error" onClick={() => handleOpenCheckOut()}>
                Final Check-Out
              </Button>
            ) : (
              <></>
            )}
            {!isRoomCheckedOut ? (
              <Button
                startIcon={<EditIcon />}
                variant="outlined"
                sx={{ marginRight: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={handleOpenEditlead}
              >
                Edit
              </Button>
            ) : (
              ''
            )}
          </Box>


        {/*---------------------- button for test whatsapp api ---------------------  */}
          {/* <Box>
            <Button
              variant="outlined"
              sx={{ marginRight: 2, color: '#673ab7', borderColor: '#673ab7' }}
              onClick={handleCheckIn}
              >
                check whatsapp API
              </Button>
          </Box> */}

        </Grid>
      </Box>

      {/* //tab panel 2---------------------------------------------------------------------------------------------------------------------------------------- */}
      <Box sx={{ width: '100%', typography: 'body1', marginTop: '30px' }}>
        <TabContext value={tabOption}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
              <Tab label="Foods" value="1" />
              <Tab label="Invoices" value="2" />
            </TabList>
          </Box>
          {/* //FOOD SECTION ------------------------------------------------------------------ */}
          <TabPanel value="1">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <ShowAllFoodItem />
            </Box>
          </TabPanel>
          <TabPanel value="2">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <ShowBill />
            </Box>
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
